module.exports = __webpack_public_path__ + "media/packs/images/download-99c85305bf8fe0b84fe010172eac0955.svg";